import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import { IDefaultResponse } from "../../models/DefaultResponse";
import { ICustomer } from "../../models/Customer/Customer";
import { CategorySearchTermQueryKeys } from "./keys";
import { ICategorySearchTerm } from "../../models/Category/Category";

// export interface IUseCategorySearchTermsProps {
//   searchTerm?: string;
//   pageNumber?: number;
//   itemsPerPage?: number;
//   includeDeleted?: boolean;
// }

export default function useCategorySearchTerms() {
    const { get, patch } = useApiHelper();
    const queryClient = useQueryClient();

    const terms = useQuery({
        queryKey: CategorySearchTermQueryKeys.all(),
        queryFn: () =>
          get<IDefaultResponse<ICategorySearchTerm[]>>(`/part/category/terms`).then((res) => res.data),
    });

    const update = useMutation({
        mutationFn: (data: any) => patch(`/part/category/terms`, data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: CategorySearchTermQueryKeys.all() });
        },
    });

    return {
        terms,
        update,
    };
}